import React from 'react';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { TOrderSummaryItem } from '@r1-frontend/ui-react/organisms/OrderSummary/types';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as S from '../styled';

const ItemWithoutCost = (
    {
        title,
        description,
        Component = Paragraph4,
        color = COLORS.TextInfo,
    }: TOrderSummaryItem,
): JSX.Element => {
    return <S.Item>
        <S.ItemTop>
            <Component $color={color} as={'span'} $withIndent={false} $inline>{title}</Component>
            <Component $color={color} as={'span'} $withIndent={false} $inline>Считаем...</Component>
        </S.ItemTop>
        {description ? <Paragraph4 $color={COLORS.TextInfo} as={'span'}>{description}</Paragraph4> : null}
    </S.Item>;
};

export default ItemWithoutCost;
